<template>
  <div class="app-container finance">
    <!-- <panelGroup :detail="detail" v-if="detail"/> -->
    <div class="financeHeader">
          时间段
          <el-date-picker
            v-model="start_datetime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择开始时间"
          ></el-date-picker>至
          <el-date-picker
            v-model="end_datetime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择结束时间"
          ></el-date-picker>
        <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
    </div>

    <el-table
      :loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="margin-top: 15px"
    >
      <el-table-column label="序号" align="center" width="95">
        <template slot-scope="scope">{{scope.$index+1}}</template>
      </el-table-column>
      <el-table-column label="订单号" align="center" min-width="150">
        <template slot-scope="scope">{{scope.row.order_no}}</template>
      </el-table-column>
      <el-table-column label="所在供应商" align="center" min-width="150">
        <template slot-scope="scope">{{scope.row.product.package_name}}</template>
      </el-table-column>
      <el-table-column label="昵称" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.name}}</template>
      </el-table-column>
      <el-table-column label="头像" align="center" min-width="150">
        <template slot-scope="scope">
          <img v-if="scope.row.user.avatar" :src="scope.row.user.avatar" alt style="width: 110px;" />
        </template>
      </el-table-column>
      <el-table-column label="联系电话" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.phone}}</template>
      </el-table-column>
      <el-table-column label="商品名称" align="center" min-width="100">
        <template slot-scope="scope">{{scope.row.product.title}}</template>
      </el-table-column>
      <el-table-column label="价格" align="center" min-width="80">
        <template slot-scope="scope">{{scope.row.pay_price}}</template>
      </el-table-column>
      <el-table-column label="酒店" align="center" min-width="80">
        <template slot-scope="scope">{{scope.row.product.package_name}}</template>
      </el-table-column>
      <el-table-column label="时间" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.created_at}}</template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[10,20,30,50]"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
// import statistical from "@/views/financial/user_statistical";
// import panelGroup from "@/components/panelGroup/index.vue";

import request from "@/utils/request";
let echarts = require("echarts/lib/echarts");
// 引入折线图组件
require("echarts/lib/chart/line");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");

export default {
  components: {
    // statistical
    // panelGroup,
  },
  data() {
    return {
      listLoading: false,
      total: null,
      listQuery: {
        page: 1,
        limit: 10,
        start_datetime: "",
        end_datetime: "",
        order_no: "",
        shop_name: "",
        shop_id:""
      },
      start_datetime: "",
      end_datetime: "",
      lineData: [],
      list: [],
      detail: {}
    };
  },
  created() {
    this.listQuery.shop_id = this.$route.query.id;
    this.month = new Date().getMonth() + 1;
    let MonthNextFirstDay = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      1
    );
    let MonthLastDay = new Date(MonthNextFirstDay - 86400000);
    this.lastDay = MonthLastDay.getDate();
    if (this.month < 10) {
      this.start_datetime =
        new Date().getFullYear() + "-" + "0" + this.month + "-" + "01";
      this.end_datetime =
        new Date().getFullYear() + "-" + "0" + this.month + "-" + this.lastDay;
    } else {
      this.start_datetime =
        new Date().getFullYear() + "-" + this.month + "-" + "01";
      this.end_datetime =
        new Date().getFullYear() + "-" + this.month + "-" + this.lastDay;
    }
  },

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      this.listLoading = true;
      this.listQuery.start_datetime = this.start_datetime
        ? this.start_datetime + " 00:00:00"
        : "";
      this.listQuery.end_datetime = this.end_datetime
        ? this.end_datetime + " 23:59:59"
        : "";
      request({
        url: "/api/backend/finance/orderList",
        method: "get",
        params: this.listQuery
      })
        .then(result => {
          this.list = result.data.data;
          this.total = result.data.total;
          // this.listLoading = false;
          console.log(this.list)
        })
        .catch(err => {
          console.log(err);
        });
    },
    getDataCount() {
      this.listQuery.start_datetime = this.start_datetime
        ? this.start_datetime + " 00:00:00"
        : "";
      this.listQuery.end_datetime = this.end_datetime
        ? this.end_datetime + " 23:59:59"
        : "";
      request({
        url: "/api/backend/finance/dataCount",
        method: "get",
        params: {
          start_datetime: this.listQuery.start_datetime,
          end_datetime: this.listQuery.end_datetime,
          school_id: this.listQuery.school_id
        }
      })
        .then(result => {
          this.detail = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getDataGraph() {
      this.listQuery.start_datetime = this.start_datetime
        ? this.start_datetime + " 00:00:00"
        : "";
      this.listQuery.end_datetime = this.end_datetime
        ? this.end_datetime + " 23:59:59"
        : "";
      request({
        url: "/api/backend/finance/dataGraph",
        method: "get",
        params: {
          start_datetime: this.listQuery.start_datetime,
          end_datetime: this.listQuery.end_datetime,
          school_id: this.listQuery.school_id
        }
      })
        .then(result => {
          this.lineData = result.data;

          this.drawLine();
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },

    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    handleSearch() {
      this.listQuery.page = 1;
      this.getList();
      this.getDataCount();
      this.getDataGraph();
    },

    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let start_datetime = this.start_datetime;
      let end_datetime = this.end_datetime;
      let date = this.get(start_datetime, end_datetime);
      // console.log(date)
      let myChart = echarts.init(document.getElementById("myChart"));
      let temporary = [];
      for (let i = 0; i < date.length; i++) {
        temporary.push(date[i]);
      }
      // temporary.push(date)
      // for (let i = 0; i < this.lineData.length; i++) {
      //   let day = parseInt(date[2]) + i
      //   if (day < 10) {
      //     day = '0'+day
      //   }
      //   temporary.push(date[1] + '/' + day)
      // }
      // console.log(this.lineData)
      // 绘制图表
      myChart.setOption({
        title: {
          text: "收入折线图"
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          // data:['课程','训练营','套票','私教','企业课']
          data: ["流水量"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          right: 50,
          feature: {
            saveAsImage: {
              show: true,
              title: "保存为图片"
            }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          // data: ['周一','周二','周三','周四','周五','周六','周日']
          data: temporary
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "流水",
            type: "line",
            stack: "总量",
            data: this.lineData
          }
        ]
      });
    },

    get(day1, day2) {
      let end_day = day2.split("-")[1] + "/" + day2.split("-")[2];
      //  console.log(end_day)
      var getDate = function(str) {
        var tempDate = new Date();
        var list = str.split("-");
        tempDate.setFullYear(list[0]);
        tempDate.setMonth(list[1] - 1);
        tempDate.setDate(list[2]);
        return tempDate;
      };
      var date1 = getDate(day1);
      var date2 = getDate(day2);
      if (date1 > date2) {
        var tempDate = date1;
        date1 = date2;
        date2 = tempDate;
      }
      date1.setDate(date1.getDate());
      var dateArr = [];
      var i = 0;
      while (
        !(
          date1.getFullYear() == date2.getFullYear() &&
          date1.getMonth() == date2.getMonth() &&
          date1.getDate() == date2.getDate()
        )
      ) {
        var dayStr = date1.getDate().toString();
        let monthStr = date1.getMonth() + 1;
        if (dayStr.length == 1) {
          dayStr = "0" + dayStr;
        }
        if (monthStr < 10) {
          monthStr = "0" + monthStr;
        }
        dateArr[i] = monthStr + "/" + dayStr; // date1.getFullYear() + "/" +
        i++;
        /*
         * document.write("<div style='display:block'>" + date1.getFullYear() +
         * "-" + (date1.getMonth() + 1) + "-" + date1.getDate() + "</div>");
         */
        // document.write(dateArr[i] + "<br>");
        date1.setDate(date1.getDate() + 1);
      }
      // dateArr.splice(0,0,day1)
      dateArr.push(end_day);
      // console.log(dateArr)
      return dateArr;
    }
  }
};
</script>

<style>
.title {
  font-size: 20px;
  margin-right: 30px;
}
.shop_finance {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.shop_finance_item {
  background-color: rgba(255, 0, 0, 0.438);
  color: #ffffff;
  border-radius: 30px;
  padding: 20px 30px;
  margin-right: 30px;
}
</style>

